import { useAsyncData, useRuntimeConfig } from '#imports'

import type { PaymentCreateFraudData } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import { useSignifyd } from '@backmarket/nuxt-layer-fraud/useSignifyd'

/**
 * Returns the Signifyd data needed to create a payment.
 */
export const useFraudData = () => {
  const isFraudCheckKilled = useRuntimeConfig().public.payment.KILL_FRAUD_CHECK

  if (isFraudCheckKilled) {
    return useAsyncData(
      'fraud-data-disabled',
      async (): Promise<PaymentCreateFraudData> => ({}),
      { server: false },
    )
  }

  const { load: getSignifydSessionId } = useSignifyd({ trigger: 'manual' })

  return useAsyncData(
    'signifyd-fraud-data',
    async (): Promise<PaymentCreateFraudData> => {
      const signifydSessionId = await getSignifydSessionId()

      return {
        ...(signifydSessionId && { signifyd_fingerprint: signifydSessionId }),
      }
    },
    {
      server: false,
    },
  )
}
